export const errorMessageIgnoreList: Array<string | RegExp> = [
  // A generic "Script Error" is logged in the browser console when an uncaught JavaScript error occurs in a file served from a different domain or subdomain.  When this happens, the browser will not provide all the details of the error for security and privacy reasons. Often referred to as 'cross domain errors'.
  'Script error',
  // Errors we believe not to originate from our code, but not picked up by our 'source domain' parsing. The error messages logically seem exceptionally unlikely to be based on Skyscanner functionality, so not Skyscanner code. Assumed to be third party scripts or browser extensions.
  `null is not an object (evaluating 'document.querySelector('video').getAttribute')`,
  'window.cobrowseIOgetRedactedElementsBounds is not a function.',
  /Blocked a frame with origin "https:\/\/www.skyscanner.+" from accessing a cross-origin frame\. Protocols, domains, and ports must match\./,
  // A browser level issue https://issues.chromium.org/issues/396043331
  'find variable: gmo',
];

export const errorSourceAllowList = [
  // Intended to allow all Skyscanner domains
  // 'skyscanner' from the below list above is deliberately a wide match to allow for domains like 'gr.skyscanner.com', 'skyscanner.net', 'skyscanner.se'. The full list of domains can be found in the culture service. However, this can result in some false positives. These are rare, so we maintain a simple ignore list in 'errorSourceDenyList' below to mitigate false positives.
  'skyscanner',
  'js.skyscnr.com',
  'css.skyscnr.com',
  'images.skyscnr.com',
  'tianxun',
  'acorn-staging.skyscanner.io',
  'banana-staging.skyscanner.io',
];

export const errorSourceIgnoreList = [
  // Seen in https://zn0vdsl2wl8zalxla-skyscanner.siteintercept.qualtrics.com
  'siteintercept.qualtrics',
];

export const browserExtensionIgnoreList = [
  'hoklmmgfnpapgjgcpechhaamimifchmp', // Similarweb – Website Traffic & SEO Checker
  'bkkbcggnhapdmkeljlodobbkopceiche', // Poper Blocker – Pop up blocker for Chrome
  'njnakjakcnkmnogiopbiomdleekeogkp', // vsHotel
  'bhmmomiinigofkjcapegjjndpbikblnp', // WOT: Website Security & Safety Checker
  'eppiocemhmnlbhjplcgkofciiegomcon', // Urban VPN Proxy
];
